import gql from 'graphql-tag'
import { graphql } from 'react-apollo'

export const applyPromoCodeMutation = graphql(
  gql`
    mutation getPromoCode($code: String!, $timeZone: Int, $designIds: [String]) {
      couponCode: getDiscountCode(code: $code, timeZone: $timeZone, designIds: $designIds) {
        code
        discountAmount
        type
        rate
        freeShipping
        restrictionType
        products
        discountItemId
        purpose
        eligibleDesigns
        includeUpgrades
        modelRestricted
        modelRestrictedName
        modelRestrictedFrom
        modelRestrictedTo
        modelRestrictedQty
        quantities {
          shortId
          quantity
        }
      }
    }
  `,
  {
    name: 'applyPromoCode',
    withRef: true
  }
)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/OrderSummary/data.ts